import { Action, createReducer, on } from '@ngrx/store';
import { adminCatalogActions } from './admin-catalog.action';
import { AdminCatalogState, adminCatalogIS } from './admin-catalog.state';

const adminCatalogRegister = createReducer(
  adminCatalogIS,
  on(adminCatalogActions.addResultAction, (state, { result }) => ({
    ...state,
    result: [...state.result, ...result],
  })),

  on(adminCatalogActions.addSubCatalogAction, (state, param) => ({
    ...state,
    subCatalogs: {
      ...state.subCatalogs,
      [param.code]: param.value,
    },
  })),

  on(adminCatalogActions.putSubCatalogAction, (state, param) => ({
    ...state,
    subCatalogs: {
      ...state.subCatalogs,
      [param.code]: [...state.subCatalogs[param.code], param.value],
    },
  })),

  on(adminCatalogActions.patchSubCatalogAction, (state, param) => ({
    ...state,
    subCatalogs: {
      ...state.subCatalogs,
      [param.code]: state.subCatalogs[param.code].map((item) => {
        if (item.id === param.value.id) {
          return param.value;
        }
        return item;
      }),
    },
  })),

  on(adminCatalogActions.setSubCatalogAction, (state, param) => ({
    ...state,
    modal: param,
  })),

  on(adminCatalogActions.setSubCatalogDefaultAction, (state) => ({
    ...state,
    modal: adminCatalogIS.modal,
  })),

  on(adminCatalogActions.setAllDefaultAction, () => adminCatalogIS)
);

export function adminCatalogReducer(
  state: AdminCatalogState,
  action: Action
): any {
  return adminCatalogRegister(state, action);
}
